// extracted by mini-css-extract-plugin
export default {"tabsContainer":"style-module__tabsContainer__YkcT_","divider":"style-module__divider__Om1kg","listItemContainer":"style-module__listItemContainer__GwlPR"};